export const NEW_EDITOR = 'NEW' as const;
export const LEGACY_EDITOR = 'LEGACY' as const;

export type EditorType = 'NEW' | 'LEGACY';

export type WorkflowPublicationStatus = 'NONE' | 'DIRTY' | 'DRAFT' | 'LIVE';
